const defaultState = {
  isLeftSideBarOpen: true,
  isADPageViewOpen: false
};

export default defaultState;
